import React from "react";

export default function PricingHero() {
    return (
        <section className="pricing-section">
            <div className="container">
                <div className="pricing-head text-center mb-5">
                    <span className="eyebrow">Pricing</span>
                    <h2 className="results-title">Simple pricing for restaurants, cafés, and bars</h2>
                    <p className="results-sub">
                        Hosting, updates, and support included. Built for speed, designed for your brand.
                    </p>
                </div>

                <div className="pricing-card mx-auto">
                    <div className="pricing-header-card text-center">
                        <div className="price">
                            <span className="currency">$</span>55<span className="per-month">/mo</span>
                        </div>
                        <p className="pricing-note">No contracts. Cancel anytime.</p>
                    </div>
                    <ul className="pricing-features">
                        <li>Custom, mobile-optimized site</li>
                        <li>Menu tools & easy updates</li>
                        <li>Online ordering & bookings</li>
                        <li>Hosting, security & support</li>
                    </ul>
                    <div className="setup-note">
                        <strong>One-time setup required</strong><br />
                        Final cost depends on your needs.
                    </div>
                    <div className="text-center mt-4">
                        <a href="/get-started" className="btn btn-accent-primary btn-lg">Get Started</a>
                    </div>
                </div>
            </div>
        </section>
    );
}
